import { render, staticRenderFns } from "./CompanyReportDialogEmployee.vue?vue&type=template&id=20a9365b"
import script from "./CompanyReportDialogEmployee.vue?vue&type=script&lang=js"
export * from "./CompanyReportDialogEmployee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports